import styled from '@emotion/styled'
import type { FC } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'

import DividerSection from '@segment/templates/DividerSection/DividerSection'

import Layout from '@segment/next-shared/layout'

import Subnavigation from './components/Subnavigation'
import Hero from './components/Hero'
import GettingStarted from './components/GettingStarted'
import BuildCustomerTrust from './components/BuildCustomerTrust'
import CuriousAbout from './components/CuriousAbout'
import CustomerEngagement from './components/CustomerEngagement'
import Security from './components/Security'
import Privacy from './components/Privacy'
import Compliance from './components/Compliance'
import Reliability from './components/Reliability/Reliability'
import RegionalSegment from './components/RegionalSegment'

const TrustCenterView: FC = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Trust Center - Privacy, Security & Compliance | Twilio Segment"
        pageDescription="Maximize customer engagement with first party data, powered by a platform you can trust. Learn how Twilio Segment diligently meets global security standards, and protects the privacy and infrastructure of our customer data platform."
      >
        <NavigationV2 after={<Subnavigation />} />
        <Hero />
        <Main>
          <CustomerEngagement />
          <DividerSection />
          <Security />
          <Privacy />
          <Compliance />
          <RegionalSegment />
          <Reliability />
          <CuriousAbout />
          <DividerSection />
          <BuildCustomerTrust />
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main``

export default TrustCenterView
